import { MouseSensor as LibMouseSensor, TouchSensor as LibTouchSensor, PointerSensor as LibPointerSensor } from '@dnd-kit/core';

// Block DnD if any ancestor has data-no-dnd.
// If a container sets data-require-drag-handle, only start drag when the target
// is within an element tagged with data-drag-handle.
const handler = ({ nativeEvent: event }) => {
  let cur = event.target;
  let hasHandleInPath = false;
  let requiresHandle = false;

  // First pass: walk up to detect flags and early no-dnd
  let iter = cur;
  while (iter) {
    if (iter.dataset) {
      if (iter.dataset.noDnd) return false;
      if (iter.dataset.dragHandle) hasHandleInPath = true;
      if (iter.dataset.requireDragHandle) requiresHandle = true;
    }
    iter = iter.parentElement;
  }

  if (requiresHandle) return hasHandleInPath;
  return true;
};

export class MouseSensor extends LibMouseSensor {
  static activators = [{ eventName: 'onMouseDown', handler }];
}

export class TouchSensor extends LibTouchSensor {
  static activators = [{ eventName: 'onTouchStart', handler }];
}

export class PointerSensor extends LibPointerSensor {
  static activators = [{ eventName: 'onPointerDown', handler }];
}